/*
  A dropdown of the header's menu row (snippets/header-dropdown-menu.liquid; sections/header.liquid links this file
  when the row has one): it closes when the focus leaves it, and the first one to open records where the header ends
  (--header-bottom-position-desktop), which caps the dropdowns' height.
*/

if (!customElements.get('header-menu')) {
  class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      const header = this.closest('.header-wrapper');
      if (!header) return;
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(header.getBoundingClientRect().bottom)}px`
      );
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
    }
  }

  customElements.define('header-menu', HeaderMenu);
}
